<div class="delivery-countdown-timer-form-configurations">
  <div class="content">
    <div class="section">
      <pdq-heading element="h5">Token for Shopify</pdq-heading>
      <div class="controls-wrapper">
        <pdq-link
          label="View detailed installation instructions"
          [external]="true"
          url="https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components"></pdq-link>
        <pdq-input
          [disabled]="true"
          [formControl]="formGroup.get('usageToken')"
          label="Copy & paste this into Shopify's Components by 'Delivery countdown timer token'"
          [clipboard]="true"></pdq-input>
        <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
      </div>
    </div>

    <div class="section">
      <pdq-heading element="h5">General</pdq-heading>
      <div class="controls-wrapper">
        <pdq-input [formControl]="formGroup.get('title')" label="Internal name"></pdq-input>
        <pdq-input [formControl]="formGroup.get('internalName')" label="Internal description"></pdq-input>
      </div>
    </div>

    <div class="section">
      <pdq-heading element="h5">Configurations</pdq-heading>
      <form [formGroup]="configurationsGroup">
        <div class="controls-wrapper">
          <div class="field-group">
            <span class="field-label">Shipping method</span>
            <pdq-radio-group [formControl]="configurationsGroup.get('shippingMethodSelectionType')">
              <pdq-radio-button
                [value]="ShippingMethodSelectionType.FASTEST_AVAILABLE"
                [checked]="
                  configurationsGroup.get('shippingMethodSelectionType')?.value ===
                  ShippingMethodSelectionType.FASTEST_AVAILABLE
                "
                text="Fastest Available Method"></pdq-radio-button>
              <pdq-radio-button
                [value]="ShippingMethodSelectionType.CHEAPEST_AVAILABLE"
                [checked]="
                  configurationsGroup.get('shippingMethodSelectionType')?.value ===
                  ShippingMethodSelectionType.CHEAPEST_AVAILABLE
                "
                text="Cheapest Available Method"></pdq-radio-button>
              <pdq-radio-button
                [value]="ShippingMethodSelectionType.MANUAL"
                [checked]="
                  configurationsGroup.get('shippingMethodSelectionType')?.value === ShippingMethodSelectionType.MANUAL
                "
                text="Manually select shipping method"></pdq-radio-button>
            </pdq-radio-group>
            @if (showShippingMethodDropdown) {
              <div class="nested-input">
                <pdq-dropdown
                  [formControl]="configurationsGroup.get('selectedShippingMethodId')"
                  [options]="shippingMethodOptions"
                  [fullWidth]="true"
                  label="Select shipping method"
                  placeholder="Choose a shipping method"></pdq-dropdown>
              </div>
            }
            <pdq-banner
              [closable]="false"
              variant="attention"
              bannerTitle="Only PDQ shipping methods with cutoff times and a single fulfillment location are supported"></pdq-banner>
          </div>

          <div class="field-group">
            <span class="field-label">Time Display Logic</span>
            <p class="description-text">Show countdown only when time remaining is between the following thresholds:</p>
            <div class="threshold-row">
              <div class="threshold-input-group">
                <span class="threshold-label">Minimum time threshold</span>
                <div class="input-with-dropdown">
                  <pdq-input
                    type="number"
                    [formControl]="configurationsGroup.get('minTimeThreshold')"
                    placeholder="0"
                    [style.width]="'120px'"></pdq-input>
                  <pdq-dropdown
                    [formControl]="configurationsGroup.get('minTimeUnit')"
                    [options]="timeUnitOptions"
                    [style.width]="'100px'"></pdq-dropdown>
                </div>
              </div>
              <div class="threshold-input-group">
                <span class="threshold-label">Maximum time threshold</span>
                <div class="input-with-dropdown">
                  <pdq-input
                    type="number"
                    [formControl]="configurationsGroup.get('maxTimeThreshold')"
                    placeholder="0"
                    [style.width]="'120px'"></pdq-input>
                  <pdq-dropdown
                    [formControl]="configurationsGroup.get('maxTimeUnit')"
                    [options]="timeUnitOptions"
                    [style.width]="'100px'"></pdq-dropdown>
                </div>
              </div>
            </div>
            @if (
              configurationsGroup.errors?.['timeThresholdMismatch'] &&
              configurationsGroup.get('minTimeThreshold')?.dirty &&
              configurationsGroup.get('maxTimeThreshold')?.dirty
            ) {
              <div class="error-message">
                {{ configurationsGroup.errors?.['timeThresholdMismatch']?.message }}
              </div>
            }
          </div>

          <div class="field-group">
            <span class="field-label">Expiration behavior</span>
            <span class="sub-label">When countdown reaches zero:</span>
            <pdq-dropdown
              [formControl]="configurationsGroup.get('expirationBehavior')"
              [options]="expirationBehaviorOptions"
              [fullWidth]="true"
              label="Select expiration behavior"
              placeholder="Choose an option"></pdq-dropdown>
            @if (showFallbackMessageInput) {
              <div class="nested-input">
                <pdq-input
                  [formControl]="configurationsGroup.get('fallbackMessage')"
                  label="Fallback message"
                  placeholder="Time for {shipping method} has passed"></pdq-input>
              </div>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
